import { Loading } from "element-ui";

let loading;
let needLoadingRequestCount = 0;

function startLoading() {
  loading = Loading.service({
    fullscreen: true,
    // target: document.getElementById("elContainer"),
    lock: true,
    text: "loading……",
    background: "rgba(0, 0, 0, 0.1)",
    customClass: "loadingBox"
  });
}

function endLoading() {
  loading.close();
}

export function showFullScreenLoading() {
  if (needLoadingRequestCount === 0) {
    startLoading();
  }
  needLoadingRequestCount++;
}

export function tryHideFullScreenLoading() {
  if (needLoadingRequestCount <= 0) return;
  needLoadingRequestCount--;
  if (needLoadingRequestCount === 0) {
    endLoading();
  }
}
